import { call, put, takeEvery } from 'redux-saga/effects';
import { DeleteDpNewsFeedAccess, dpNewsFeedActionCreators, DpNewsFeedActionKeys, IDpNewsFeedPost } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { deleteDpPostAccess } from '../dpNewsFeedApi';

function* deleteDpNewsFeedAccessSaga(action: DeleteDpNewsFeedAccess) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<IDpNewsFeedPost> = yield call(
    deleteDpPostAccess,
    action.payload.dpNewsFeedPostAccessId
  );

  if (!response.requestFailed) {
    if (response.value) {
      yield put(dpNewsFeedActionCreators.setPosts([response.value]));
    }
  } else {
    yield showFailedRequestDialog(response);
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchDeleteDpNewsFeedAccess() {
  yield takeEvery(DpNewsFeedActionKeys.DELELTE_DP_NEWS_FEED_ACCESS, deleteDpNewsFeedAccessSaga);
}
